export enum AUTH_STATUS {
  SUCESS = 'success',
  LOADING = 'loading',
  IDLE = 'idle',
}
